import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./ViewMyClient.scss";
import {
    BiPhoneCall,
    BiBuildingHouse,
    BiMailSend,
    BiMapAlt,
    BiTimeFive,
    BiBuildings,
    BiUserCheck,
    BiLayer,
    BiEdit,
    BiTrash,
    BiReceipt,
    BiMoney,
    BiCalendar,
    BiCheckCircle,
    BiTime,
    BiXCircle
} from "react-icons/bi";
import { useAuth } from "../../context/AuthContext";
import { getUserData } from "../../services/api/AuthApi";
import { getMyClientsByID, deleteMyClient } from "../../services/api/MyClientsApi";
import { ClientCaseComponent } from "../../components/ClientCaseComponent";
import { getBothCourtCasesDetailsByCourtRef } from "../../services/api/CasesApi";
import { useLoading } from "../../context/LoadingContext";
import { formatText } from "../../components/TruncateParties";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal/DeleteConfirmationModal";
import { getInvoicesByClientId } from "../../services/api/InvoicesApi";

const ViewMyClient = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { company } = useAuth()
    console.log(company, "comp")
    const [createdByName, setCreatedByName] = useState("Loading...");
    const [companyName, setCompanyName] = useState("Loading...");
    const { showLoading, hideLoading } = useLoading();
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [client, setClient] = useState(null);
    const [allCases, setAllCases] = useState({ high: [], district: [], other: [] });
    const [loadingCases, setLoadingCases] = useState(true);
    const [invoices, setInvoices] = useState(null);
    const [loadingInvoices, setLoadingInvoices] = useState(true);

    useEffect(() => {
    if (loadingCases) {
        showLoading("Loading...");
    } else {
        hideLoading();
    }
}, [loadingCases, showLoading, hideLoading]);

    useEffect(() => {
        if (id) {
            //showLoading("Loading client details...");
            getMyClientsByID(id)
                .then(async (res) => {
                    const data = res.data;
                    setClient(data);

                    // Fetch Created By name
                    if (data.createdBy) {       
                        try {
                            const userRes = await getUserData(data.createdBy);
                            setCreatedByName(userRes.data.name || "Unknown");
                        } catch (err) {
                            console.error("Failed to fetch user name", err);
                            setCreatedByName("Unknown");
                        }
                    } else {
                        setCreatedByName("System");
                    }

                    // Set company name from useAuth
                    if (company?.companyName) {
                        setCompanyName(company.companyName);
                    } else {
                        setCompanyName("Independent");
                    }

                    // Batch fetch all case details for all court types
                    setLoadingCases(true);
                    const fetchCases = async () => {
                        const fetchList = async (ids) =>
                            Promise.all((ids || []).map(async (id) => {
                                try {
                                    const res = await getBothCourtCasesDetailsByCourtRef(id);
                                    return { caseId: id, data: res.data };
                                } catch (e) {
                                    return { caseId: id, error: true };
                                }
                            }));
                        const [high, district, other] = await Promise.all([
                            fetchList(data.highCourtCases),
                            fetchList(data.districtCourtCases),
                            fetchList(data.otherCourtCases),
                        ]);
                        setAllCases({ high, district, other });
                        setLoadingCases(false);
                    };
                    fetchCases();

                    // Fetch invoices for this client
                    setLoadingInvoices(true);
                    getInvoicesByClientId(data._id)
                        .then((invoiceRes) => {
                            setInvoices(invoiceRes.data);
                            setLoadingInvoices(false);
                        })
                        .catch((err) => {
                            console.error("Failed to fetch invoices", err);
                            setInvoices(null);
                            setLoadingInvoices(false);
                        });

                    //hideLoading();
                })
                .catch((err) => {
                    console.error("Failed to fetch client", err);
                    //hideLoading();
                });
        }
    }, [id, company]);

    const handleEdit = () => {
        navigate(`/home/my-clients/edit/${client._id}`, { state: client });
    };

    const handleDelete = () => {
        setShowDeleteModal(true);
    };

    const confirmDelete = async () => {
        try {
            await deleteMyClient(id);
            navigate("/my-clients");
        } catch (error) {
            console.error("Failed to delete client:", error);
        }
        setShowDeleteModal(false);
    };

    const cancelDelete = () => {
        setShowDeleteModal(false);
    };

    if (!client) {
        return (
            <div className="client-detail-container">
                <div className="error-message">Client not found.</div>
            </div>
        );
    }
    // if (loadingCases) {
    //     return (
    //         <div className="client-detail-container">
    //             <div className="loading-message">Loading cases...</div>
    //         </div>
    //         //<JusticeLoader />
    //         //showLoading("Loading cases...")
    //     );
    // }
    

    return (
        <div className="client-detail-container">
            <div className="client-card">
                <div className="client-header">
                  <div className="client-header-data">
                    <div className="avatar">{client.name.charAt(0)}</div>
                    <div className="client-title">
                        <h2>{client.salutation} {formatText(client.name)}</h2>
                        <p className="company">{formatText(client.company) || "Independent"}</p>
                    </div>
                    </div>
                    <div className="client-actions">
                        <button className="btn-update" onClick={handleEdit}>
                            <BiEdit /> Update
                        </button>
                        <button className="btn-delete" onClick={handleDelete}>
                            <BiTrash /> Delete
                        </button>
                    </div>
                </div>

                <div className="client-details-grid">
                    <div className="view-client-detail-item">
                        <BiPhoneCall className="icon" />
                        <div>
                            <label>Phone</label>
                            <p>{client.phno}</p>
                        </div>
                    </div>
                    {client.alternateContact && 
                    <div className="view-client-detail-item">
                        <BiPhoneCall className="icon" />
                        <div>
                        <label>Alt. Contact</label>
                        <p>{client.alternateContact}</p>
                        </div>
                    </div>}

                    <div className="view-client-detail-item">
                        <BiBuildingHouse className="icon" />
                        <div>
                            <label>GSTIN</label>
                            <p>{client.gstin || "N/A"}</p>
                        </div>
                    </div>

                    <div className="view-client-detail-item">
                        <BiTimeFive className="icon" />
                        <div>
                            <label>Created At</label>
                            <p>{new Date(client.createdAt).toLocaleString()}</p>
                        </div>
                    </div>

                    <div className="view-client-detail-item">
                        <BiTimeFive className="icon" />
                        <div>
                            <label>Updated At</label>
                            <p>{new Date(client.updatedAt).toLocaleString()}</p>
                        </div>
                    </div>

                    {/* <div className="view-client-detail-item"><BiBuildings className="icon" /><label>Company ID</label><p>{client.companyId || "N/A"}</p></div> */}

                    <div className="view-client-detail-item">
                        <BiBuildings className="icon" />
                        <div>
                            <label>Company</label>
                            <p>{formatText(companyName)}</p>
                        </div>
                    </div>

                    {/* <div className="view-client-detail-item"><BiUserCheck className="icon" /><label>Created By</label><p>{client.createdBy || "System"}</p></div> */}
                    <div className="view-client-detail-item">
                        <BiUserCheck className="icon" />
                        <div>
                            <label>Created By</label>
                            <p>{formatText(createdByName)}</p>
                        </div>
                    </div>
                    <div className="view-client-detail-item">
                        <BiMailSend className="icon" />
                        <div>
                            <label>Email</label>
                            <p>{client.email}</p>
                        </div>
                    </div>
                    <div className="view-client-detail-item">
                        <BiMapAlt className="icon" />
                        <div>
                            <label>Address</label>
                        <p>
                            {client.addressLine1}, {client.addressLine2}
                            {/* {client.city}, {client.state}, {client.country} - {client.zipcode} */}
                        </p>
                        </div>
                    </div>
                </div>

                {allCases.high.length > 0 && (
                    <div className="client-cases">
                        <h3><BiLayer /> High Court Cases</h3>
                        <ul>
                            {allCases.high.map((caseObj, idx) => (
                                <ClientCaseComponent key={caseObj.caseId || idx} caseData={caseObj} />
                            ))}
                        </ul>
                    </div>
                )}
                {allCases.district.length > 0 && (
                    <div className="client-cases">
                        <h3><BiLayer /> District Court Cases</h3>
                        <ul>
                            {allCases.district.map((caseObj, idx) => (
                                <ClientCaseComponent key={caseObj.caseId || idx} caseData={caseObj} />
                            ))}
                        </ul>
                    </div>
                )}
                {allCases.other.length > 0 && (
                    <div className="client-cases">
                        <h3><BiLayer /> Other Court Cases</h3>
                        <ul>
                            {allCases.other.map((caseObj, idx) => (
                                <ClientCaseComponent key={caseObj.caseId || idx} caseData={caseObj} />
                            ))}
                        </ul>
                    </div>
                )}

                {/* Invoice Section */}
                <div className="client-invoices">
                    <h3><BiReceipt /> Invoices</h3>
                    {loadingInvoices ? (
                        <div className="loading-message">Loading invoices...</div>
                    ) : invoices && invoices.invoice && invoices.invoice.length > 0 ? (
                        <>
                            <div className="invoice-summary">
                                <div className="summary-item">
                                    <BiReceipt className="summary-icon" />
                                    <div>
                                        <label>Total Invoices</label>
                                        <p className="summary-value">{invoices.total}</p>
                                    </div>
                                </div>
                                <div className="summary-item success">
                                    <BiCheckCircle className="summary-icon" />
                                    <div>
                                        <label>Paid</label>
                                        <p className="summary-value">₹{invoices.totalAmountPaid?.toLocaleString('en-IN') || 0}</p>
                                        <span className="count">({invoices.totalPaid} invoices)</span>
                                    </div>
                                </div>
                                <div className="summary-item warning">
                                    <BiTime className="summary-icon" />
                                    <div>
                                        <label>Part Payment</label>
                                        <p className="summary-value">₹{invoices.totalAmountPartPayment?.toLocaleString('en-IN') || 0}</p>
                                        <span className="count">({invoices.totalPartPayment} invoices)</span>
                                    </div>
                                </div>
                                <div className="summary-item pending">
                                    <BiMoney className="summary-icon" />
                                    <div>
                                        <label>Pending</label>
                                        <p className="summary-value">₹{invoices.totalAmountPending?.toLocaleString('en-IN') || 0}</p>
                                        <span className="count">({invoices.totalPending} invoices)</span>
                                    </div>
                                </div>
                                {invoices.totalCancelled > 0 && (
                                    <div className="summary-item cancelled">
                                        <BiXCircle className="summary-icon" />
                                        <div>
                                            <label>Cancelled</label>
                                            <p className="summary-value">₹{invoices.totalAmountCancelled?.toLocaleString('en-IN') || 0}</p>
                                            <span className="count">({invoices.totalCancelled} invoices)</span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="invoice-list">
                                {invoices.invoice.map((invoice) => (
                                    <div key={invoice._id} className="invoice-card">
                                        <div className="invoice-header">
                                            <div className="invoice-number">
                                                <BiReceipt />
                                                <span>{invoice.invoiceNumber}</span>
                                            </div>
                                            <div className={`invoice-status status-${invoice.status}`}>
                                                {invoice.status === 'paid' && <BiCheckCircle />}
                                                {invoice.status === 'pending' && <BiMoney />}
                                                {invoice.status === 'part-payment' && <BiTime />}
                                                {invoice.status === 'cancelled' && <BiXCircle />}
                                                <span>{invoice.status.replace('-', ' ').toUpperCase()}</span>
                                            </div>
                                        </div>

                                        <div className="invoice-body">
                                            <div className="invoice-details">
                                                <div className="detail-row">
                                                    <BiCalendar />
                                                    <span>Created: {new Date(invoice.createdAt).toLocaleDateString('en-IN')}</span>
                                                </div>
                                                <div className="detail-row">
                                                    <BiMoney />
                                                    <span>Total Amount: ₹{invoice.totalAmount?.toLocaleString('en-IN')}</span>
                                                </div>
                                                <div className="detail-row">
                                                    <span>Subtotal: ₹{invoice.subtotal?.toLocaleString('en-IN')}</span>
                                                </div>
                                                {invoice.cgstAmount > 0 && (
                                                    <div className="detail-row">
                                                        <span>CGST ({invoice.cgstPercentage}%): ₹{invoice.cgstAmount?.toLocaleString('en-IN')}</span>
                                                    </div>
                                                )}
                                                {invoice.sgstAmount > 0 && (
                                                    <div className="detail-row">
                                                        <span>SGST ({invoice.sgstPercentage}%): ₹{invoice.sgstAmount?.toLocaleString('en-IN')}</span>
                                                    </div>
                                                )}
                                                {invoice.igstAmount > 0 && (
                                                    <div className="detail-row">
                                                        <span>IGST ({invoice.igstPercentage}%): ₹{invoice.igstAmount?.toLocaleString('en-IN')}</span>
                                                    </div>
                                                )}
                                            </div>

                                            {invoice.items && invoice.items.length > 0 && (
                                                <div className="invoice-items">
                                                    <h4>Items</h4>
                                                    <div className="items-table">
                                                        <div className="items-table-header">
                                                            <div className="col-item">Item</div>
                                                            <div className="col-qty">Qty</div>
                                                            <div className="col-rate">Rate</div>
                                                            <div className="col-amount">Amount</div>
                                                        </div>
                                                        <div className="items-table-body">
                                                            {invoice.items.map((item, idx) => (
                                                                <div key={idx} className="items-table-row">
                                                                    <div className="col-item">
                                                                        <div className="item-name">{item.name}</div>
                                                                        {item.description && (
                                                                            <div className="item-description">{item.description}</div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-qty">{item.qty}</div>
                                                                    <div className="col-rate">₹{item.rate?.toLocaleString('en-IN')}</div>
                                                                    <div className="col-amount">₹{item.amount?.toLocaleString('en-IN')}</div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {invoice.payments && invoice.payments.length > 0 && (
                                                <div className="invoice-payments">
                                                    <h4>Payments:</h4>
                                                    {invoice.payments.map((payment, idx) => (
                                                        <div key={idx} className="payment-item">
                                                            <div className="payment-details">
                                                                <BiCheckCircle className="payment-icon" />
                                                                <span className="payment-type">{payment.paymentType}</span>
                                                                <span className="payment-amount">₹{payment.amount?.toLocaleString('en-IN')}</span>
                                                            </div>
                                                            <div className="payment-meta">
                                                                <span>Receipt: {payment.recieptId}</span>
                                                                <span>Date: {new Date(payment.paymentDate).toLocaleDateString('en-IN')}</span>
                                                                {payment.refNumber && <span>Ref: {payment.refNumber}</span>}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <div className="no-invoices">No invoices found for this client.</div>
                    )}
                </div>
            </div>
            
            <DeleteConfirmationModal
                isOpen={showDeleteModal}
                itemType={`client "${client?.name}"`}
                onConfirm={confirmDelete}
                onCancel={cancelDelete}
            />
        </div>
    );
};

export default ViewMyClient;